import {
  QueryClient,
  QueryClientProvider as ProQueryClientProvider,
} from '@tanstack/react-query'

export const queryClient = new QueryClient()

function onError() {
  // const { response, cause } = error;
  // // 后端返回信息
  // if (cause) {
  //   notifyErrorDebounce({
  //     description: cause.suggest,
  //     message: cause.msg,
  //   });
  //   return;
  // }
  // notifyErrorDebounce({
  //   description:
  //     response?.data?.message ||
  //     REQUEST_ERROR_STATUS[(response?.status ?? 0) as keyof {}],
  //   message: "异常提示",
  // });
}

queryClient.setDefaultOptions({
  queries: {
    refetchOnWindowFocus: false,
    // @ts-ignore
    onError,
    retry: false,
    // staleTime: 1000 * 60 * 5, // 5分钟
  },
  mutations: {
    onError,
  },
})

export const QueryClientProvider = (props: {
  children: React.ReactElement | React.ReactNode
}) => (
  <ProQueryClientProvider client={queryClient}>
    {props.children}
  </ProQueryClientProvider>
)
